import type { OrderResponse, OrderWriteRequest } from 'apiConnector/secondary-market/shared/order';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

export function secondaryMarketOrderPlacementActionsFactory<
  PlaceOrderReq extends OrderWriteRequest,
  PlaceOrderRes extends OrderResponse,
>(actionType: Extract<OrderActionType, 'LIMIT_ORDER'>) {
  return {
    secondaryMarketOrderPlacementRequested: (
      tabId: string,
      workspaceType: SecondaryWorkspaceType,
      request: PlaceOrderReq,
    ) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_PLACEMENT_REQUESTED` as const,
        tabId,
        workspaceType,
        request,
      };
    },
    secondaryMarketOrderPlacementReceived: (tabId: string, data: PlaceOrderRes, timestamp: Date) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_PLACEMENT_RECEIVED` as const,
        tabId,
        data,
        timestamp,
      };
    },

    secondaryMarketOrderPlacementRejected: (tabId: string, error: string, timeout?: number) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_PLACEMENT_REJECTED` as const,
        tabId,
        error,
        timeout,
      };
    },
    secondaryMarketOrderPlacementFailed: (tabId: string, error: string, timeout?: number) => {
      return {
        type: `SECONDARY_MARKET_${actionType}_PLACEMENT_FAILED` as const,
        tabId,
        error,
        timeout,
      };
    },
  };
}
